<template>
  <div class="level level-bordered">
    <!-- <div class="level-item has-text-centered border-right">
      <div>
        <p class="title is-4">{{ranking}}</p>
        <p class="heading">Ranking</p>
      </div>
    </div>
    <div class="level-item has-text-centered border-right">
      <div>
        <p class="title is-4">{{category}}</p>
        <p class="heading">Categoria</p>
      </div>
    </div> -->
    <div class="level-item has-text-centered border-right">
      <div>
        <p class="title is-5" :style="{color:colorScore}">{{score}}%</p>
        <p class="heading">Promedio General</p>
      </div>
    </div>
    <div class="level-item has-text-centered">
      <div>
        <p class="title is-5">{{horsesCount}}</p>
        <p class="heading">N° Caballos</p>
      </div>
    </div>
    <!-- <div class="level-item has-text-centered border-right">
      <div>
        <p class="title is-5">{{lesson}}</p>
        <p class="heading">Nivel Actual</p>
      </div>
    </div>
    <div class="level-item has-text-centered">
      <div>
        <p class="title is-5" :style="{color:statusColor}">{{statusText}}</p>
        <p class="heading">Estado</p>
      </div>
    </div> -->
  </div>
</template>

<script>
import LessonService from '@/services/LessonService.js'

export default {
  props: {
    rider: {
      required: true,
      type: Object
    },
    totalScore: {
      required: false,
      default: 0,
      type: Number
    }
  },
  created () {
    // this.calculateStatus()
  },
  data () {
    return {
      statusColor: '#424242',
      statusText: 'S/I'
    }
  },
  computed: {
    horsesCount () {
      return this.rider.horses ? this.rider.horses.length : 'S/I'
    },
    score () {
      return this.totalScore.toFixed(2)
    },
    colorScore () {
      return this.score > 60 ? '#23d160' : '#ff3860'
    }
  },
  methods: {
    async calculateStatus () {
      let currentLessonId = this.horse.lesson.id
      let horseAge = this.horse.age.years

      let lessonsResponse = await LessonService.getLessons()
      let lessons = lessonsResponse.data.data
      lessons.forEach(item => {
        let lesson = lessons.find((x) => x.id === currentLessonId)
        if (lesson.appropriate_age === horseAge) {
          this.statusColor = '#'
          this.statusText = 'Medio'
        } else if (lesson.appropriate_age > horseAge) {
          this.statusColor = '#23d160'
          this.statusText = 'Alto'
        } else if (lesson.appropriate_age < horseAge) {
          this.statusColor = '#ffdd57'
          this.statusText = 'Bajo'
        } else {
          this.statusColor = '#424242'
          this.statusText = 'S/I'
        }
      })
    }
  }
}
</script>
